/**
 * Przechowuje akcję odłożoną na czas płatności BLIK (dodanie utworu, dedykacji
 * albo głosu, gdy event wymaga napiwku).
 *
 * Gość przy potwierdzaniu BLIK-a przechodzi do aplikacji banku, a przeglądarka
 * na telefonie potrafi w tym czasie usunąć uśpioną kartę z pamięci. Po powrocie
 * strona wczytuje się od nowa i stan Reacta - razem z informacją, co miało zostać
 * dodane po opłaceniu - przepada. Napiwek jest wtedy pobrany, a utwór nie trafia
 * na listę. Dlatego zapisujemy tę intencję poza pamięcią komponentu.
 */

const STORAGE_KEY = 'jukebox.pendingTipAction';

// Po tym czasie odłożona akcja jest bezwartościowa: kod BLIK dawno wygasł,
// a gość zdążył wyjść z imprezy.
const MAX_AGE_MS = 30 * 60 * 1000;

export const savePendingTipAction = (eventId, payload, guestName) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({
      eventId,
      payload,
      guestName,
      clientSecret: null,
      createdAt: Date.now(),
    }));
  } catch (e) {
    // Prywatne okno albo zapełniony storage - działamy dalej bez wznawiania.
  }
};

/**
 * Dopina dane utworzonej płatności, żeby po przeładowaniu strony dało się sprawdzić
 * w Stripe, czy pieniądze faktycznie wpłynęły, i dopisać napiwek hostowi.
 *
 * @param {number} amount - kwota w złotych (tak zapisujemy napiwki w bazie)
 * @param {boolean} serverSide - czy dodanie wykona serwer (webhook/notify)
 */
export const attachPaymentToPendingTipAction = (clientSecret, amount, guestName, serverSide = false) => {
  try {
    const pending = loadPendingTipAction();
    if (!pending) return;
    localStorage.setItem(STORAGE_KEY, JSON.stringify({
      ...pending,
      clientSecret,
      amount,
      guestName: guestName || pending.guestName,
      // true = odłożoną akcję wykona serwer przy zapisie napiwku, przeglądarka
      // ma tylko odświeżyć listę (inaczej utwór dodałby się dwa razy).
      serverSide,
    }));
  } catch (e) {
    // jw.
  }
};

export const loadPendingTipAction = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;

    const pending = JSON.parse(raw);
    if (!pending?.eventId || !pending?.payload || Date.now() - (pending.createdAt || 0) > MAX_AGE_MS) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }

    return pending;
  } catch (e) {
    return null;
  }
};

export const clearPendingTipAction = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    // jw.
  }
};
